import React from 'react';
import dayjs from 'dayjs';
import parse from 'html-react-parser';
import styled from 'styled-components';

import { NoteType } from '../common/types';
import { StyledDeleteButton, StyledEditButton } from '../features/dictionaries/DictionaryItemsList';
import Icon from '../icons/Icon';

import { StyledRow } from './StyledRow';

const StyledNote = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  min-width: 285px;
  padding: 10px 10px;
  box-shadow: 0px 3px 9px #00000029;
  border-radius: 4px;
  overflow-y: auto;
`;

const NoteText = styled.div`
  font-size: 14px;
  overflow-y: auto;
  word-break: break-all;
  white-space: pre-line;
`;

type NoteProps = {
  note: NoteType;
  onEdit: (noteId: number) => void;
  onDelete: (noteId: number) => void;
};

export const Note: React.FC<NoteProps> = ({ note, onEdit, onDelete }) => {
  const title = `${dayjs.unix(note.createdDate).format('DD-MM-YYYY')} | ${note.createdBy}`;

  const handleDelete = () => {
    onDelete(note.id);
  };

  const handleEdit = () => {
    onEdit(note.id);
  };

  return (
    <StyledNote>
      <StyledRow justifyContent="space-between">
        <div style={{ fontSize: '16px', color: '#757575' }}>{title}</div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <StyledEditButton
            type="text"
            size="small"
            onClick={handleEdit}
            icon={<Icon name="Edit" inlineStyle={true} style={{ verticalAlign: '-0.2rem' }} />}
          />
          <StyledDeleteButton
            type="text"
            size="small"
            onClick={handleDelete}
            icon={<Icon name="Delete" inlineStyle={true} style={{ verticalAlign: '-0.2rem' }} />}
          />
        </div>
      </StyledRow>
      <NoteText>{parse(note.content || '')}</NoteText>
    </StyledNote>
  );
};
